<template>
  <div class="data-balance-rechange">
    <div class="page-title">
      {{ $t('merchant.account_balance') }}
    </div>
    <div class="rechange-middle">
      <div class="custom-breadcrumbs">
        <i class="el-icon-arrow-left icon-back" @click="onClickFistBread('Financial_Manage_Balance')" />
        <span class="first-span" @click="onClickFistBread('Financial_Manage_Balance')">{{ $t('data.recharge_record') }}</span>
        <span style="margin: 0 12px"> /</span>

        <span>  {{ $t('data.step') }} {{ activeStep ===1 ? 1 : 2 }}</span>
      </div>

      <el-form
        v-if="activeStep === 1 && $store.getters.isAllCountry"
        label-position="left"
        :model="rechargeForm"
        label-width="150px"
        class="recharge-currency-form"
      >
        <el-form-item
          :label="$t('data.top_up_currency') + ':'"
          prop="currency"
          :rules="[
            { required: true, message: $t('data.top_up_currency'), trigger: 'change' }
          ]"
        >
          <el-select
            v-model="rechargeForm.currency"
            class="recharge-currency-select"
            size="small"
            :placeholder="$t('data.top_up_currency')"
            clearable
            @change="onRechargeCurrencyChange"
          >
            <el-option
              v-for="(item, index) in $store.state.page.countryArr"
              :key="index"
              :label="item.currency"
              :value="item.currency"
            />
          </el-select>
        </el-form-item>
      </el-form>

      <div v-if="activeStep === 1 && (!$store.getters.isAllCountry || rechargeForm.currency)" class="select-bank-title">
        {{ $t('data.select_bank') }}
      </div>
      <div class="select-bank">
        <div v-if="activeStep === 1 && (!$store.getters.isAllCountry || rechargeForm.currency)" class="bank-container">
          <span v-for="(item,index) in bankList" :key="index" :class="{bank:true,active: activeIndex === index}" @click="onClickBank(index)">{{ item.bank }}</span>
        </div>
        <div v-if="activeStep === 2" class="tip-enter">
          {{ $t('data.enter_top_up_amount') }}
        </div>
        <el-form ref="rechargeForm" label-position="left" :model="rechargeForm" status-icon label-width="150px">
          <el-form-item
            v-if="activeStep === 2"
            :label="$t('data.payment_type')+':'"
            prop="top_up_type"
            :rules="[
              { required: true, message: 'Payment Type cannot be empty', trigger: ['blur', 'change']}
            ]"
          >
            <el-radio-group v-if="showBankInfo.bank === 'Chillpay'" v-model="rechargeForm.top_up_type">
              <el-radio :label="4">{{ $t('data.thai_qr_payment') }}</el-radio>
            </el-radio-group>
            <el-radio-group v-else v-model="rechargeForm.top_up_type">
              <el-radio :label="1">{{ $t('data.online_banking') }}</el-radio>
              <el-radio :label="2">{{ $t('data.offline_check') }}</el-radio>
              <el-radio :label="3">{{ $t('data.offline_cash') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="activeStep === 2"
            :label="$t('data.payment_account')+':'"
            prop="bank_no"
            :rules="[
              { required: true, message: 'Payment Account cannot be empty', trigger: 'blur'}
            ]"
          >
            <el-select
              v-model="rechargeForm.bank_no"
              class="input-item"
              size="small"
              :placeholder="$t('data.payment_account')"
              clearable
              @change="$forceUpdate()"
            >
              <el-option
                v-for="(item,index) in accountList"
                :key="index"
                :label="item.settlement_bank + '-' + item.settlement_bank_account_num"
                :value="item.bank_no"
              />
            </el-select>
            <br>
            <span v-if="accountList.length === 0" style="color: #71110e;font-size: 12px;">
              {{ $t('tips.not_bank_account') }}
            </span>
            <span v-if="accountList.length === 0" style="color: #3855f1;cursor: pointer;font-size: 12px;padding-left: 10px;" @click="$router.push({name:'Financial_Manage_Setting'})">Go to Add</span>
          </el-form-item>
          <el-form-item
            v-if="activeStep === 2"
            :label="showBankInfo.bank !== 'Chillpay'? $t('components.amount') : $t('data.top_up_amount') +':'"
            prop="amount"
            :rules="[
              { required: true, message: 'Amount cannot be empty', trigger: 'blur'},
              { validator: checkAmount, trigger: 'blur' }
            ]"
          >
            <el-input v-model="rechargeForm.amount" size="small" type="text" placeholder="Enter amount" class="input-item" autocomplete="off"><template slot="prepend">{{ $store.getters.isAllCountry ? rechargeForm.currency : $store.getters.currency }} </template></el-input>
            <span v-if="showBankInfo.bank === 'Chillpay'" style="font-size: 12px;color: #7A869E;;line-height: 1.5;"> ( {{ $store.getters.isMX ? $t('tips.qr_tips') : $t('tips.thai_qr_tips') }})</span>
          </el-form-item>
          <el-form-item
            v-if="activeStep === 2"
            :label="$t('merchantAccount.money_source')+':'"
            prop="money_source"
            :rules="[
              { required: true, message: 'Source of Funds cannot be empty', trigger: 'blur'},
            ]"
          >
            <el-select v-model="rechargeForm.money_source" size="small" :placeholder="$t('merchantAccount.money_source')" class="input-item" clearable>
              <el-option
                v-for="(item,index) in fundsSourceMap"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <br>
            <el-input v-show="rechargeForm.money_source === 99" v-model="rechargeForm.money_source_defined" class="input-item" :placeholder="$t('map.funds_source_99')" type="text" size="small" autocomplete="off" clearable />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div v-if="!$store.getters.isAllCountry || (rechargeForm.currency && showBankInfo.id)" class="content">

      <p class="info">{{ $t('data.bank_details') }}</p>

      <div>
        <p class="tip">{{ $t('data.recharge_tip') }}</p>
        <el-descriptions :column="1">
          <el-descriptions-item label-class-name="bank-label" :label="$t('merchant.account_name')">
            <span class="bank-info">{{ showBankInfo.bank_account_name | cryptoJSAesDecrypt }}</span>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="bank-label" :label="$t('merchant.account_bank')">
            <span class="bank-info">{{ showBankInfo.bank_full_name }}</span>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="bank-label" :label="$t('merchant.account_num')">
            <span class="bank-info">{{ showBankInfo.bank_account | cryptoJSAesDecrypt }}</span>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="bank-label" :label="$t('merchant.company_address')">
            <span v-if="$store.getters.curCountry.country_code === 'PH'" class="bank-info">Unit 905, One Global Place, 5th Avenue corner 25th Street, Bonifacio Global City, Fort Bonifacio, Taguig City</span>
            <span v-else class="bank-info">-</span>
          </el-descriptions-item>
          <el-descriptions-item label-class-name="bank-label" :label="$t('merchant.account_address')">
            <span class="bank-info">{{ showBankInfo.bank_address }}</span>
          </el-descriptions-item>
        </el-descriptions>

      </div>

      <template v-if="activeStep === 2">
        <el-divider class="divider" />

        <p class="info"><span style="color:#71110e;">*</span>{{ $t('data.upload_receipt') }}</p>

        <div>
          <p class="tip">{{ $t('tips.upload_receipt_tip') }}</p>
          <UploadFile
            :accept-type="'.jpg,.png,.jpeg,.webp,.pdf,.PDF,.JPG,.PNG,.JPEG,.WEBP'"
            :limit-num="5"
            :list="urlList"
            type="recharge"
            @templateFileSuccess="templateFileSuccess"
            v-on="$listeners"
          />
          <!-- <div>
            <el-image
              v-for="item in urlList"
              :key="item.absolutePath"
              :src="item.absolutePath"
              style="width:200px"
              :preview-src-list="urlList.map(i => i.absolutePath)"></el-image>
          </div> -->
          <div v-for="item in urlList" :key="item._uid" style="margin-bottom: 10px">
            <span class="content-file" @click="onClickFileName(item.relativePath)">{{ item.fileName }}</span>
            <el-button type="danger" size="mini" style="margin-left: 10px" icon="el-icon-delete" @click="onClickRemoveBtn(item)">{{ $t('components.delete') }}</el-button>
          </div>
        </div>

        <el-divider class="divider" />

        <p class="info">{{ $t('data.remark') }}</p>

        <el-input
          v-model="rechargeForm.remark"
          type="textarea"
          :rows="6"
          style="width:515px;height:133px;margin-bottom:20px"
          maxlength="250"
          placeholder="Enter message or remarks"
        />
      </template>

      <div slot="footer" class="dialog-footer">
        <el-button v-if="activeStep===1" type="info" :disabled="submiting || !showBankInfo.id" class="btn-footer" @click="nextButton()">{{ $t('components.next') }}</el-button>
        <el-button v-if="activeStep===2" :disabled="submiting" class="btn-footer btn-defalt" @click="activeStep = 1">{{ $t('components.previous') }}</el-button>
        <el-button v-if="activeStep===2" type="info" :disabled="submiting" class="btn-footer" @click="onClickSubmitBtn('form')">{{ $t('components.submit') }}</el-button>
      </div>
      <RechargeSuccessModal ref="rechargeSuccessModal" @closeModal="closeModal" />
      <RechargeSuccessModalThaiQR ref="rechargeSuccessModalThaiQR" @closeModal="closeModal" />
      <el-dialog :visible.sync="dialogImageVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  mchRecharge,
  multiMchRecharge,
  fetchBankList,
  GetRechargeInfo,
  bankQueryList,
  multiMchBankQueryList,
  fetchMultiMchBankList
} from '@/api/merchant-manage/merchant-manage.js'
import { fetchRelativePath } from '@/api/components/upload.js'
import RechargeSuccessModal from './components/Modal/RechargeSuccessModal.vue'
import { fundsSourceMap } from '@/utils/maps'
import RechargeSuccessModalThaiQR from '@/views/paycools/data/components/Modal/RechargeSuccessModalThaiQR.vue'
import { preCalculate } from '@/api/settlement/settlement'
import serviceConst from '@/const/serviceConst.json'

export default {
  name: 'Balance_Rechange',
  components: {
    RechargeSuccessModal,
    RechargeSuccessModalThaiQR,
    UploadFile: () => import('@/views/components/Upload/UploadFile.vue')
  },
  data() {
    this.checkAmount = (rule, value, callback) => {
      let validationError
      this.$commonFn.validateFormAmount({
        rule,
        value: Number(value),
        countryCode: this.selectedCountryCode,
        callback: error => {
          validationError = error
        }
      })
      callback(validationError)
    }
    return {
      submiting: false,
      bankList: [],
      accountList: [],
      urlList: [],
      activeStep: 1,
      activeIndex: 0,
      showBankInfo: {},
      rechargeForm: { amount: '', currency: '' },
      dialogImageUrl: '',
      dialogImageVisible: false,
      looking: false
    }
  },
  computed: {
    fundsSourceMap() {
      return fundsSourceMap()
    },
    selectedCountryCode() {
      if (!this.$store.getters.isAllCountry) {
        return this.$store.getters.curCountry.country_code
      }
      const selectedCountry = this.$store.state.page.countryArr.find(item => item.currency === this.rechargeForm.currency)
      return selectedCountry ? selectedCountry.code : ''
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const bankListRequest = this.$store.getters.isAllCountry
        ? Promise.resolve({ data: [] })
        : fetchBankList()

      Promise.all([bankListRequest, this.getAccountList()]).then(res => {
        const [sysBankData] = res
        if (!this.$store.getters.isAllCountry) {
          const sysData = sysBankData.data || []
          this.bankList = sysData
          this.showBankInfo = sysData[0] ? JSON.parse(JSON.stringify(sysData[0])) : {}
        }

        // 默认第一个
        // this.rechargeForm.bank_no = this.accountList[0] && this.accountList[0].bank_no
        this.getRechargeInfo()
        if (this.$route.query.amount) {
          this.rechargeForm.amount = this.$route.query.amount
        }
      })
    },
    getBankList(currency) {
      this.bankList = []
      this.showBankInfo = {}
      this.activeIndex = 0

      if (!currency) {
        return Promise.resolve()
      }

      const fetchBankListApi = this.$store.getters.isAllCountry
        ? fetchMultiMchBankList
        : fetchBankList
      return fetchBankListApi({ currency }).then(res => {
        if (this.rechargeForm.currency !== currency) {
          return
        }
        const bankList = res.data || []
        this.bankList = bankList
        this.showBankInfo = bankList[0] ? JSON.parse(JSON.stringify(bankList[0])) : {}
      })
    },
    onRechargeCurrencyChange(currency) {
      this.rechargeForm.bank_no = ''
      Promise.all([
        this.getBankList(currency),
        this.getAccountList(currency)
      ])
    },
    getAccountList(currency) {
      this.accountList = []

      if (this.$store.getters.isAllCountry && !currency) {
        return Promise.resolve()
      }

      const params = { audit_status: 2, use_status: 1 }
      if (this.$store.getters.isAllCountry) {
        params.currency = currency
      }

      const bankQueryListApi = this.$store.getters.isAllCountry
        ? multiMchBankQueryList
        : bankQueryList
      return bankQueryListApi(params).then(res => {
        if (this.$store.getters.isAllCountry && this.rechargeForm.currency !== currency) {
          return
        }
        const accountList = res.data || []
        this.accountList = accountList.filter(item => item.audit_status === 2)
      })
    },
    getRechargeInfo() {
      const id = this.$route.query.id
      if (this.$route.query.id) {
        GetRechargeInfo({ id }).then(async res => {
          const rechargeInfo = res.data
          const { issuing_bank_account_num, sys_bank_id } = rechargeInfo
          if (this.$store.getters.isAllCountry) {
            this.rechargeForm.currency = rechargeInfo.currency || ''
            await Promise.all([
              this.getBankList(this.rechargeForm.currency),
              this.getAccountList(this.rechargeForm.currency)
            ])
          }
          const curRechargeBank = this.accountList.find(item => item.settlement_bank_account_num === issuing_bank_account_num)
          const item = this.bankList.find(i => i.id === sys_bank_id)
          const index = this.bankList.findIndex(i => i.id === sys_bank_id)
          this.showBankInfo = item || {}
          this.activeIndex = index
          this.activeStep = 2
          this.rechargeForm = {
            ...rechargeInfo,
            currency: this.$store.getters.isAllCountry ? this.rechargeForm.currency : rechargeInfo.currency,
            bank_no: curRechargeBank ? curRechargeBank.bank_no : rechargeInfo.bank_no,
            amount: rechargeInfo.amount / 100
          }
          this.urlList = rechargeInfo.voucher_url.map((i, index) => ({
            absolutePath: rechargeInfo.voucher_url_oss_url[index],
            relativePath: i,
            fileName: i.replace(/^(file\/)/, ''),
            _uid: Date.now() + Math.random() + index
          }))
        })
      }
    },
    onClickFileName(url) {
      if (this.looking) {
        return
      }
      this.looking = true
      fetchRelativePath({ filename: url }).then(res => {
        this.doFileView(res.data)
      }).finally(() => {
        this.looking = false
      })
    },
    doFileView(relativePath) {
      if (!/\.(pdf|PDF)/.test(relativePath)) {
        if (/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)/.test(relativePath)) {
          this.dialogImageVisible = true
          this.dialogImageUrl = relativePath
          return
        }
        const url = encodeURIComponent(relativePath)
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + url,
          '_blank'
        )
        return false
      } else {
        window.open(relativePath, '_blank')
      }
    },
    onClickRemoveBtn(item) {
      this.urlList = this.urlList.filter(i => i._uid !== item._uid)
    },
    templateFileSuccess(data) {
      this.urlList.push({
        ...data,
        _uid: Date.now() + Math.random()
      })
    },
    onClickBank(index) {
      this.activeIndex = index
      this.showBankInfo = this.bankList[index]
    },
    onClickSubmitBtn() {
      this.$refs.rechargeForm.validate((valid) => {
        if (valid) {
          if (!this.urlList.length) return this.$message.warning('Please upload at least one image!')
          this.submiting = true
          const params = {
            amount: this.$commonFn.mathMultiply(Number(this.rechargeForm.amount), 100),
            sys_bank_id: this.showBankInfo.id,
            bank_no: this.rechargeForm.bank_no,
            top_up_type: this.rechargeForm.top_up_type,
            remark: this.rechargeForm.remark,
            voucher_url: this.urlList.map(i => i.relativePath),
            id: this.rechargeForm.id,
            money_source: this.rechargeForm.money_source,
            money_source_defined: this.rechargeForm.money_source_defined
          }
          if (this.$store.getters.isAllCountry) {
            params.currency = this.rechargeForm.currency
          }
          params.manual_repay_flag = !!this.$route.query.amount
          const obj = JSON.parse(JSON.stringify(params))
          const rechargeApi = this.$store.getters.isAllCountry
            ? multiMchRecharge
            : mchRecharge
          rechargeApi(params).then(res => {
            if (this.showBankInfo.bank === 'Chillpay') {
              setTimeout(() => {
                this.$refs.rechargeSuccessModalThaiQR.changModalStatus(true, obj.amount / 100)
              }, 500)
            } else {
              setTimeout(() => {
                this.$refs.rechargeSuccessModal.changModalStatus(
                  true,
                  obj.amount / 100,
                  obj.currency || this.$store.getters.currency
                )
              }, 500)
            }
            this.nsds_pay_tip()
            this.$emit('get-merchant-info')
          }).finally(() => {
            this.submiting = false
          })
        } else {
          this.$message.warning('Please check if any required fields are not filled!')
        }
      })
    },
    nsds_pay_tip() {
      if (this.$route.query.name === 'NSDS_PAY') {
        preCalculate().then(res => {
          if (res.code === serviceConst.resCode.succ) {
            console.log(this.$commonFn.mathMultiply(Number(this.rechargeForm.amount), 100))
            console.log(res.data.total_amount)
            if (this.$commonFn.mathMultiply(Number(this.rechargeForm.amount), 100) < res.data.total_amount) {
              this.$message.warning(this.$t('tips.nsds_pay_tip'))
            }
          }
        }).finally(() => {
          this.rechargeForm.amount = ''
        })
      }
    },
    closeModal() {
      this.$router.push({ name: 'Financial_Manage_Balance', params: { activeName: 'Recharge_Record' }})
    },
    onClickFistBread(name) {
      this.$router.push({ name })
    },
    nextButton() {
      if (this.showBankInfo.bank === 'Chillpay') {
        this.$confirm(this.$t('tips.chillpay_tips'), this.$t('components.tips'), {
          confirmButtonText: this.$t('components.confirm'),
          cancelButtonText: this.$t('components.cancel'),
          type: 'warning'
        }).then(() => {
          this.activeStep = 2
          this.rechargeForm.top_up_type = 4
        })
      } else {
        this.activeStep = 2
      }
    }
  }
}
</script>
<style>
.data-balance-rechange .bank-label{
    width: 210px;
    font-size: 14px;
    color: #1D3A71;
    font-weight: 500;  font-family: 'Inter-Medium';
}
</style>
<style lang="scss" scoped>
.upload-box {
  ::v-deep .el-upload-dragger {
    width: 515px;
  }
}
.divider {
  background: #D3D7DF;
}
.bank-info{
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  color: #434343;
}
.data-balance-rechange{
  margin: 40px 57px 50px 32px;
  .rechange-middle{
   border-top: 1px solid #D3D7DF;
    border-bottom: 1px solid #D3D7DF;
  }
  .custom-breadcrumbs{
    display: flex;
    justify-items: center;
    margin: 32px 0 40px;
    color: #3855F1;
    cursor: pointer;
    .icon-back{
      margin-right: 12px;
      margin-top: 2px;
    }
    // .first-span{
    //   margin-right: 12px;
    // }
  }
  .select-bank-title{
    margin-bottom: 16px;
    font-weight: 500;  font-family: 'Inter-Medium';
    font-size: 16px;
    color: #1D3A71;
  }
  .recharge-currency-form{
    margin-bottom: 16px;
  }
  .recharge-currency-select{
    width: 364px;
  }
  .select-bank{
    .bank{
      display: inline-block;
      margin-right: 24px;
      margin-bottom: 32px;
      padding: 10px 50px;
      border-radius: 2px;
      font-size: 14px;
      text-align: center;
      color: #1D3A71;
      background: #FFFFFF;
      border: 1px solid #1D3A71;
      cursor: pointer;
      &.active{
        color: #FFFFFF;
        background: #1D3A71;
      }
    }
  }
  .input-item{
    width: 364px;
  }
  .tip-enter{
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #7A869E;
  }
  .info{
    margin-top: 32px;
    margin-bottom: 16px;
    font-weight: 500;  font-family: 'Inter-Medium';
    font-size: 18px;
    color: #3855F1;
  }
  .tip{
    margin-bottom: 32px;
    font-weight: 400;
    font-size: 14px;
    color: #7A869E;
  }

 .dialog-footer{
    padding-top: 18px;
    .btn-footer{
      width: 132px;
      height: 40px;
      font-size: 12px;
      // color: #FFFFFF;
      // background: #3855F1;
      border-radius: 4px;
      &:hover{
        opacity: .9;
      }
    }
    .btn-defalt{
      margin-right: 10px;
      color: #616D85;
      background: #FFFFFF;
      border: 1px solid #98A1B4;
    }
  }
}
.content-file{
  display: inline-block;
  width: 330px;
  vertical-align: middle;
  color:#3855F1;
  text-decoration: underline;
  cursor: pointer;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
}

</style>
